import React from 'react';
import ImagenesManager from '../Components/Catalogos/Imagenes/ImagenesManager';

/**
 * ImagenesPage - Página principal para la gestión de imágenes del sistema.
 * Muestra el gestor visual (Grid Layout - Tarjetas).
 */
export default function ImagenesPage() {
    return (
        <ImagenesManager />
    );
}
